module.exports = __webpack_public_path__ + "img/sign_stopped_alarm.e7394689.png";